import { render, staticRenderFns } from "./Orientacao.vue?vue&type=template&id=d73d3416&scoped=true&"
import script from "./Orientacao.vue?vue&type=script&lang=js&"
export * from "./Orientacao.vue?vue&type=script&lang=js&"
import style0 from "./Orientacao.vue?vue&type=style&index=0&id=d73d3416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73d3416",
  null
  
)

export default component.exports